"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _events = _interopRequireDefault(require("./events"));

var _Image = require("./Image");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Group =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Group, _PureComponent);

  function Group() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Group.prototype;

  _proto.handleClick = function handleClick(index) {
    var children = this.props.children;
    var images = [];
    var current = 0;

    _react.Children.toArray(children).forEach(function (child, i) {
      if (child && child.type && child.type.symbolType === _Image.IMAGE) {
        if (index === i) current = images.length;
        var _child$props = child.props,
            src = _child$props.src,
            href = _child$props.href;
        images.push({
          thumb: src,
          src: href || src,
          key: i
        });
      }
    });

    (0, _events.default)(images, current);
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        children = _this$props.children,
        pile = _this$props.pile,
        style = _this$props.style,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "pile", "style"]);

    return _react.default.createElement("div", {
      className: (0, _styles.imageClass)('group', pile && 'pile'),
      style: style
    }, _react.Children.toArray(this.props.children).map(function (child, i) {
      return (0, _react.cloneElement)(child, _objectSpread({}, props, {
        onClick: _this.handleClick.bind(_this, i)
      }));
    }));
  };

  return Group;
}(_react.PureComponent);

Group.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.array]),
  pile: _propTypes.default.bool,
  style: _propTypes.default.object
};
var _default = Group;
exports.default = _default;